<template>
  <v-autocomplete
    v-model="VALOR_SELECIONADO"
    :label="label"
    :items="grupos"
    item-value="id"
    item-text="descricao"
    :outlined="outlined"
    clearable
    v-bind="$attrs"
    small-chips
  />
</template>

<script>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import req from "@/api/drp.js";
import {iniciarRequisicao, logout} from "@/helpers";

export default {
  name: "GruposSeparacaoAutocomplete",
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: [String, Number],
    label: {
      type: String,
      default: 'Grupos de separação',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const VALOR_SELECIONADO = computed({
      get: () => props.modelValue,
      set: valor => emit('update:modelValue', valor || ''),
    });

    const grupos = ref([]);

    onMounted(buscarGrupos);

    function buscarGrupos() {
      store.dispatch('loading/addRequisicao',
        req.getGrupoSeparacao(iniciarRequisicao())
          .then((response) => {
            const {token, gruposeparacao} = response.data;
            localStorage.token = token;
            grupos.value = gruposeparacao;
          })
          .catch(logout)
      );
    }

    return {
      VALOR_SELECIONADO,
      grupos,
    };
  }
}
</script>

<style scoped>

</style>
